import React from 'react'
import WorkItemPopup from './WorkItemPopup'

const WorkItem = ({ item, title }) => {
    return (
        <div className={`col col-d-6 col-t-6 col-m-12 grid-item ${item.image.type} border-line-h`}>
            <div className="box-item">
                <div className="image">
                    <a href={item.image.link} className={`has-popup-${item.image.type}`}>
                        <img src={item.image.imageLink} alt="" />
                        <span className="info">
                            <span className={`ion ion-${item.image.cardIcon}`}></span>
                        </span>
                    </a>
                </div>
                <div className="desc">
                    <a href={item.image.link} className={`name has-popup-${item.image.type}`}>{item.description.name}</a>
                    <div className="category">{item.description.category}</div>
                </div>
                {item.hasContent && (
                    <WorkItemPopup title={title} item={item} />
                )}
            </div>
        </div>
    )
}

export default WorkItem